import { Link } from 'react-router';
import { Home, Search } from 'lucide-react';
import { Button } from '../components/ui/button';

export default function NotFound() {
  return (
    <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-[#8B7109] to-[#9A7B4F]">
      <div className="text-center px-4">
        <div className="mb-8">
          <h1 className="text-9xl font-bold text-white mb-4">404</h1>
          <div className="flex items-center justify-center gap-2 text-[#FFE5A0] mb-4">
            <div className="h-px w-12 bg-[#FFE5A0]"></div>
            <Search className="w-6 h-6" />
            <div className="h-px w-12 bg-[#FFE5A0]"></div>
          </div>
          <h2 className="text-3xl font-bold text-white mb-4">الصفحة غير موجودة</h2>
          <p className="text-white/80 text-lg mb-8 max-w-md mx-auto">
            عذراً، الصفحة التي تبحث عنها غير موجودة أو تم نقلها
          </p>
        </div>

        <div className="flex flex-wrap gap-4 justify-center">
          <Link to="/">
            <Button className="bg-[#D4AF37] hover:bg-[#B8960C] text-white px-8 py-6 text-lg">
              <Home className="w-5 h-5 ml-2" />
              العودة للرئيسية
            </Button>
          </Link>
          <Link to="/properties">
            <Button variant="outline" className="border-2 border-white text-white hover:bg-white hover:text-gray-800 px-8 py-6 text-lg">
              <Search className="w-5 h-5 ml-2" />
              تصفح العقارات
            </Button>
          </Link>
        </div>
      </div>
    </div>
  );
}